var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-pagination",
        {
          class: [_vm.align],
          attrs: {
            background: "",
            "current-page": _vm.pagination.pageIndex,
            "page-sizes": _vm.pageSizes,
            "page-size": _vm.pagination.pageSize,
            layout: _vm.layout,
            total: _vm.pagination.dataCount
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange
          }
        },
        [
          _c("span", { staticClass: "el-pagination__total" }, [
            _vm._v("共 " + _vm._s(_vm.pagination.dataCount) + " 条记录")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46f67908", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46f67908","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListPagination.vue
// module id = 529
// module chunks = 14